import { types} from "mobx-state-tree";

export const BehaviorModalState = types.model('BehaviorModalState', {
  title: types.maybe(types.string),
  uuid: types.maybe(types.string)
}).actions(self => ({}))

